import { graphql } from "gql";

const ORGANIZATION_QUERY = graphql(`
  query Organization {
    organization {
      ...Organization
    }
  }
`);

export default ORGANIZATION_QUERY;
